import { LS } from './storage';

export const getSessionToken = () => LS.get('bcToken');

export const authHeaders = () => {
    const token = getSessionToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// fetch + 인증 헤더 + JSON 본문 처리
export const apiFetch = (url, { json, headers, ...options } = {}) => fetch(url, {
    ...options,
    headers: {
        ...authHeaders(),
        ...(json !== undefined ? { 'Content-Type': 'application/json' } : {}),
        ...headers,
    },
    body: json !== undefined ? JSON.stringify(json) : options.body,
});

// JSON 응답을 돌려주고, 실패 시 서버 메시지를 담은 Error 를 던진다
export const apiJson = async (url, options) => {
    const res = await apiFetch(url, options);
    const text = await res.text();
    let data = null;
    try { data = text ? JSON.parse(text) : null; } catch {}
    if (!res.ok) {
        throw Object.assign(new Error(data?.error || data?.message || `요청 실패 (${res.status})`), { status: res.status });
    }
    return data;
};
